// components
import type { BoxProps } from '@mui/material';
import { styled, Box, alpha } from '@mui/material';

export const StyledNoAccessMainBox = styled(Box)<BoxProps>(({ theme }) => ({
  padding: theme.spacing(4),
  boxSizing: 'border-box',
  width: 'calc(100vw - 110px)',
  height: 'calc(100vh - 56px)',
  textAlign: 'center',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: theme.spacing(2),
  justifyContent: 'center'
}));

export const StyledNoAccessInnerBox = styled(Box)<BoxProps>(({ theme }) => ({
  margin: theme.spacing(4),
  backgroundColor: alpha(theme.palette.primary.main, 0.06),
  width: '100%',
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: theme.shape.borderRadius,
  border: `1px dashed ${alpha(theme.palette.primary.main, 0.2)}`
}));
